module.exports = __webpack_public_path__ + "img/ht.20f5689d.png";